import {
    CONFIG_LOAD,
    CONFIG_RELOAD,
    CONFIG_RECEIVE
} from '../constants';
import {
    LoadAction,
    ReloadAction,
    ReceiveAction
} from '~/frontend/src/actions/config';


export type ConfigState = Partial<{
    isLoading : boolean;
    isReady : boolean;
}>;


const relevantActions = [
    CONFIG_LOAD,
    CONFIG_RELOAD,
    CONFIG_RECEIVE
];


export default function configReducer( state : ConfigState = {}, action : LoadAction | ReloadAction | ReceiveAction ) : ConfigState {
    let retVal = state;

    if ( relevantActions.includes( action.type ) ) {
        retVal = {
            ...state
        };

        switch ( action.type ) {
            case CONFIG_LOAD:
                retVal.isLoading = true;
                break;

            case CONFIG_RELOAD:
                retVal.isReady = false;
                retVal.isLoading = true;
                break;

            case CONFIG_RECEIVE:
                retVal.isReady = true;
                retVal.isLoading = false;
                break;
        }
    }

    return retVal;
}
